import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Baocaoxedien from "components/Baocao/Xedien/Baocaoxedien.js";
export default function BCBenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo thí điểm xe điện",
            tabContent: <Baocaoxedien />,
          },
        ]}
      />
    </div>
  );
}
